var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMisc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 34,
    viewBox: "0 0 52 34",
    width: 52,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h52v34h-52z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#3a3a3a",
    strokeWidth: 1.5,
    transform: "translate(10.001 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24.009 4.822h3.225a1.393 1.393 0 0 1 1.366 1.13l4.3 22.317",
    strokeLinecap: "round",
    transform: "translate(-4.861 -4.822)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.252 33.129h14.012a1.394 1.394 0 0 0 1.2-.681l6.225-10.465",
    transform: "translate(-4.861 -4.822)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.616 24.239h16.999"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 3.557,
    cy: 26.198,
    r: 3.557,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.557,
    cy: 26.198,
    fill: "none",
    r: 2.807
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 28.443,
    cy: 26.198,
    r: 3.557,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.443,
    cy: 26.198,
    fill: "none",
    r: 2.807
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMisc);
export default __webpack_public_path__ + "static/media/misc.acac55dd926014fded18fda73b1518a3.svg";
export { ForwardRef as ReactComponent };